import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ASSORTMENTS } from "constants/integration/assortments";
import { formatMessage } from "lib/globalize-util";
import React from "react";
import { IAttributeDataError, IImportDataError } from "./types";

type ErrorMessagesListProps = {
    errorMessages: IAttributeDataError | IImportDataError;
};

const ErrorMessagesList = ({ errorMessages = {} }: ErrorMessagesListProps) => (
    <ul>
        {Object.keys(errorMessages).map((key, index) => (
            <li
                key={`${key}-${index}`}
                data-test={`${ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.ERRORS.MESSAGE}-${index}`}
            >
                {errorMessages[key]}
            </li>
        ))}
    </ul>
);

interface ErrorWhileUploadingFileProps {
    errorMessages: IAttributeDataError | IImportDataError;
}

export const ErrorWhileUploadingFile = ({ errorMessages }: ErrorWhileUploadingFileProps) => {
    const classes = useStylesErrorMessages();
    return (
        <Box className={classes.root}>
            <p className={classes.label}>{formatMessage("We found the following errors with your upload:")}</p>
            <ErrorMessagesList errorMessages={errorMessages} />
        </Box>
    );
};

export const useStylesErrorMessages = makeStyles({
    root: {
        fontWeight: 400,
        fontSize: 16,
        "& li": {
            margin: 5,
            minWidth: 200,
            paddingLeft: "1em",
            "&:before": {
                content: '"\\2022"',
                color: "currentColor",
                fontWeight: "bold",
                display: "inline-block",
                width: "1.5em",
                marginLeft: "-1.5em",
            },
        },
    },
    label: {
        fontWeight: 400,
        fontSize: 18,
    },
});
